

import React, { useState } from "react";
import { Tabs, ConfigProvider} from "antd";
import ListDevice from "./tab-component/ListDevice";
import RegisterUser from "./tab-component/RegisterUser";
import ListTreatedDevice from "./tab-component/ListTreatedDevice";
import OrganisationList from "./tab-component/OrganisationList";
import AllCertificates from "./tab-component/AllCertificates";
import ListDevice2 from "./tab-component/ListDevice2";


const BioTabs = () => {
  
  const tabBarStyle = {
    width: '100%',
    textAlign: 'center',
  };
  const items = [
    {
      key: "1",
      label: `Device List`,
      children: <ListDevice2 />,
    },
    {
      key: "2",
      label: `Add Vendor`,
      children: <RegisterUser />,
    },
    {
      key: "3",
      label: `Treated Applications`,
      children: <ListTreatedDevice />,
    },
    {
      key: "4",
      label: `Issued Certificate`,
      children: <AllCertificates/>,
    },
    {
      key: "5",
      label: `Organisation Names`,
      children: <OrganisationList />,
    },
    

  ];
  const [activeTab, setActiveTab] = useState(items[0].key)
  const [visitedTabs, setVisitedTabs] = useState(() => {
    const storedKey = localStorage.getItem("activeTab");
    return storedKey ? [storedKey] : ["1"];
  });

  const handleTabChange = (key) => {
    
    setActiveTab(key); // Update active tab key when tab changes
  };

  const onTabClick = (key) => {
    localStorage.setItem("activeTab", key);
    if (!visitedTabs.includes(key)) {
      setVisitedTabs([...visitedTabs, key]);
    }
  };
  
  return (
    <ConfigProvider
    theme={{
      components: {
        Tabs: {
          colorPrimary: '#1A472B',
          colorPrimaryHover: '#464947',
          colorPrimaryActive: '#464947',
          fontSize:15
        },
      },
    }}
  >
    <Tabs
      activeKey={activeTab}
      defaultActiveKey={visitedTabs[0]}
      onChange={handleTabChange}
      onTabClick={onTabClick}
      tabPosition="top"
      tabBarStyle={tabBarStyle}
      renderTabBar={(props, DefaultTabBar) => (
        <DefaultTabBar {...props}>
          {React.Children.map(props.children, (child, index) =>
            React.cloneElement(child, {
              visible: visitedTabs.includes(child.key),
            })
          )}
        </DefaultTabBar>
      )}
    >
      {items.map((item) => (
        <Tabs.TabPane key={item.key} tab={item.label}>
          {activeTab === item.key && item.children}
        </Tabs.TabPane>
      ))}
    </Tabs>
    </ConfigProvider>
  );
};

export default BioTabs;

